import script from "./Suggest.vue?vue&type=script&lang=ts&setup=true"
export * from "./Suggest.vue?vue&type=script&lang=ts&setup=true"

import "./Suggest.vue?vue&type=style&index=0&id=68770316&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68770316"]])

export default __exports__